import { Component, inject, OnInit } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, Subject, switchMap, takeUntil } from 'rxjs';
import { AttorneyReferral, FlagAnalysis, GetItemsParams, Patient, ReportListData } from '../service/reports.model';
import { SharedService } from 'src/app/services/shared.service';
import { ReportsService } from '../service/reports.service';
import { CaseType, ToastType } from 'src/app/enums/enums';
import { ApiService } from 'src/app/services/api.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'reprot-app-attorney',
  templateUrl: './attorney.component.html',
  styleUrls: ['./attorney.component.scss']
})
export class ReportAttorneyComponent implements OnInit {
  calendar = inject(NgbCalendar);
  private Unsubscribe = new Subject<void>();
  public PaginationParams!: GetItemsParams;
  public IsLoading = false;
  public TotaReports = 0;
  public reportList: any[] = [];

  fromDate: NgbDate | null = this.calendar.getNext(this.calendar.getToday(), 'd', -10);
  fromStr = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
  toDate: NgbDate | null = this.calendar.getToday();
  toStr = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
  public SearchVal: string = '';
  currentClinic = 0;

  constructor(public sharedService: SharedService, private reportsService: ReportsService, public apiService: ApiService, private toast: ToastService) {
    this.PaginationParams = {
      sortColumn: 'firstName',
      clinicId: this.sharedService.CurrentClinic.value || 0,
      sortOrder: 'asc',
      fromDate: this.fromStr,
      toDate: this.toStr
    };
  }
  ngOnInit(): void {
    this.currentClinic = this.sharedService.CurrentClinic.value || 0;
    this.sharedService.CurrentClinic.pipe(takeUntil(this.Unsubscribe)).subscribe((val) => {
      this.PaginationParams.clinicId = Number(val);
      this.currentClinic = Number(val);
      this.GetAttorneyReferralReport(this.PaginationParams);
    });
  }

  GetAttorneyReferralReport(params: GetItemsParams) {
    this.IsLoading = true;
    this.reportsService.getReports<AttorneyReferral>(params, 'AttorneyReferral').subscribe({
      next: (res) => {
        this.reportList = [...res.result];
        this.TotaReports = this.reportList.length;
      },
      error: (err) => {
        this.IsLoading = false;
      },
      complete: () => (this.IsLoading = false)
    });
  }

  toDateChange(date: string) {
    this.toStr = date;
    this.PaginationParams.toDate = date;
    this.GetAttorneyReferralReport(this.PaginationParams);
  }

  fromDateChange(date: string) {
    this.PaginationParams.fromDate = date;
    this.fromStr = date;
  }

  exportReport() {
    this.reportsService.exportReport(this.PaginationParams, 'AttorneyReferral').subscribe({
      next: (res) => {
        this.toast.showToast({ message: res.message, type: ToastType.Success });
      },
      error: (err) => {
        this.toast.showToast({ message: err.message, type: ToastType.Error });
      },
      complete: () => {}
    });
  }

  SortData(sortBy: string) {
    this.PaginationParams.sortColumn = sortBy;
    this.PaginationParams.sortOrder = this.PaginationParams.sortOrder === 'asc' ? 'desc' : 'asc';
    this.GetAttorneyReferralReport(this.PaginationParams);
  }

  getCaseName(id: number): string {
    return CaseType[id] || '';
  }

  ngOnDestroy(): void {
    this.Unsubscribe.next();
    this.Unsubscribe.complete();
  }
}
